import { PDFDocument, rgb, StandardFonts } from 'pdf-lib'
import QRCodeUtils from '@/utils/QRCodeUtils'
import FileReaderUtils from '@/utils/fileReaderUtils'

const REASONS =
{
    TRAVAIL: 579,
    SANTE: 546,
    FAMILLE: 512,
    HANDICAP: 478,
    JUDICIAIRE: 460,
    MISSIONS: 410,
    TRANSIT: 378,
    ANIMAUX: 343,
    COURSES: 280,
    SPORT: 235,
    RASSEMBLEMENT: 167,
    DEMARCHE: 121,
}

/**
 * 
 * @param {Array<number>} reasonsYPos 
 */
async function generatePdf ({lastName, firstName, birthDate, birthPlace, address, zipcode, city} = {}, reasonsYPos)
{
    const creationInstant = new Date()
    const creationDate = creationInstant.toLocaleDateString('fr-FR')
    const creationHour = creationInstant
        .toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
        .replace(':', 'h')

    const datesortie = creationDate
    const heuresortie = creationHour

    const reasonNames = reasonsYPos.map(r => Object.entries(REASONS).find(e => e[1] == r)[0]).join(', ')
    const data =
    [
        `Cree le: ${creationDate} a ${creationHour}`,
        `Nom: ${lastName}`,
        `Prenom: ${firstName}`,
        `Naissance: ${birthDate} a ${birthPlace}`,
        `Adresse: ${address} ${zipcode} ${city}`,
        `Sortie: ${datesortie} a ${heuresortie}`,
        `Motifs: ${reasonNames}`,
    ].join(';\n ')

    const existingPdfBytes = await FileReaderUtils.readAsArrayBufferAsync(await FileReaderUtils.srcToBlobAsync('https://static.app-maville.com/find/covid/certificate-3.pdf'))
    const pdfDoc = await PDFDocument.load(existingPdfBytes)

    pdfDoc.setTitle('COVID-19 - Déclaration de déplacement')
    pdfDoc.setSubject('Attestation de déplacement dérogatoire')
    pdfDoc.setKeywords
    ([
        'covid19',
        'covid-19',
        'attestation',
        'déclaration',
        'déplacement',
        'officielle',
        'gouvernement',
    ])
    pdfDoc.setProducer('DNUM/SDIT')
    pdfDoc.setCreator('')
    pdfDoc.setAuthor('Ministère de l\'intérieur')

    const page1 = pdfDoc.getPages()[0]

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
    const drawText = (text, x, y, size = 11) =>
    {
        page1.drawText(text, { x, y, size, font })
    }

    drawText(`${firstName} ${lastName}`, 144, 705)
    drawText(birthDate, 144, 684)
    drawText(birthPlace, 310, 684)
    drawText(`${address}, ${zipcode} ${city}`, 148, 665)

    reasonsYPos.forEach(reason =>
    {
        drawText('x', 72, reason, 12)
    })

    let locationSize = getIdealFontSize(font, city, 83, 7, 11)

    if (!locationSize)
    {
      alert(
        'Le nom de la ville risque de ne pas être affiché correctement en raison de sa longueur. ' +
            'Essayez d\'utiliser des abréviations ("Saint" en "St." par exemple) quand cela est possible.',
      )
      locationSize = 7
    }

    drawText(city, 103, 99, locationSize)
    drawText(`${datesortie}`, 91, 83, 11)
    drawText(`${heuresortie}`, 310, 83, 11)

    const qrTitle1 = 'QR-code contenant les informations '
    const qrTitle2 = 'de votre attestation numérique'

    page1.drawText(qrTitle1 + '\n' + qrTitle2, { x: 440, y: 630, size: 6, font, lineHeight: 10, color: rgb(1, 1, 1) })
    
    const generatedQR = await QRCodeUtils.toDataURL({data})
    const qrImage = await pdfDoc.embedPng(generatedQR)
    page1.drawImage(qrImage,
    {
        x: page1.getWidth() - 107,
        y: 660,
        width: 82,
        height: 82,
    })

    pdfDoc.addPage()
    const page2 = pdfDoc.getPages()[1]
    page2.drawText(qrTitle1 + qrTitle2, { x: 50, y: page2.getHeight() - 70, size: 11, font, color: rgb(1, 1, 1) })

    page2.drawImage(qrImage,
    {
        x: 50,
        y: page2.getHeight() - 390,
        width: 300,
        height: 300,
    })

    const pdfBytes = await pdfDoc.save()

    return new Blob([pdfBytes], { type: 'application/pdf' })
}

function getIdealFontSize (font, text, maxWidth, minSize, defaultSize)
{
    let currentSize = defaultSize
    let textWidth = font.widthOfTextAtSize(text, defaultSize)

    while (textWidth > maxWidth && currentSize > minSize)
    {
        textWidth = font.widthOfTextAtSize(text, --currentSize)
    }

    return textWidth > maxWidth ? null : currentSize
}

export default { generatePdf, REASONS }


// WEBPACK FOOTER //
// ./src/utils/covidPDFUtils.js